import React from "react";
import { component_tool } from "@/tool";
import { WizTableForm } from '@/containers/common';
import moment from "moment";
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY.MM.DD HH.mm.ss') : '';
}
//配置项
const componentName = "classStudentManagement";
let ref;
const _columns =() =>{
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "姓名",
      name: "fullName",
      dataIndex: "fullName",
      searchItem: {},
      tableItem: {
        width: 120,
      },
      formItem: {}
    },
    {
      title: "账号",
      name: "userName",
      dataIndex: "userName",
      searchItem: {},
      tableItem: {
        width: 120,
      },
      formItem: {}
    },
    {
      title: '手机号',
      name: 'mobile',
      tableItem: {
        width: 120,
      }
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        diy: WizTableForm,
        ...organizationConfig,
      }
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        diy: WizTableForm,
        ...positionConfig,
      }
    },

    {
      title: "组织名称",
      name: "orgName",
      tableItem: {
        // width: 180,
      }
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {
        // width: 100,
      },
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {
        // width: 100,
      }
    },
    {
      title: "任职状态",
      name: "jobState",
      dict: [
        {code: 0, codeName: '离职'},
        {code: 1, codeName: '在职'},
      ],
      tableItem: {
        // width: 100,
      },
    },
    {
      title: "是否请假",
      name: "leaveState",
      dict: [
        {code: 0, codeName: "否"},
        {code: 1, codeName: "是"}
      ],
      tableItem: {
        // width: 100,
      },
      searchItem: {
        type: 'select'
      }
    },
    {
      title: "操作类型",
      name: "operationType",
      dict: [
        {code: 0, codeName: "下载"},
        {code: 1, codeName: "阅读"}
      ],
      tableItem: {
        // width: 100,
      },
      searchItem: {
        type: 'select'
      }
    },
    {
      title: "操作时间",
      name: "operationTime",
      tableItem: {
        // width: 100,
      },
    },
  ];
}

const templateConfig = (date) => {
  const {onSelect,classInfoId ,entityId,classAideId,aideTypeId,_btnLookUserFun,_this,aideTypeName} = date;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref && ref.getSelectRows(rows)
  };
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: _columns(),
        btnAccessCheck:false,
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出记录', type:'primary'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
          onSelect: _onSelect
        },
        commonOperate: {
          update: false
        },
        rowOperateSort: [],
        rowOperateView: [ ]
      }
    }
  }
};



let reduxTemplateConfig = args => {
  const { classInfoId ,entityId,classAideId,aideTypeId} = args;
  const apis = {
    list: {
      path: `${componentName}/contentRecordByPage`,
      payload: {
        key: `${componentName}@contentRecordByPage`,
        apiParams: { classInfoId: classInfoId,entityId: entityId,classAideId:classAideId,aideTypeId:aideTypeId}
      }
    },
    export: {
      path: `${componentName}/contentRecordByList`,
      payload: {
        key: `${componentName}@contentRecordByList`,
        apiParams: { classInfoId: classInfoId,entityId: entityId,classAideId:classAideId,aideTypeId:aideTypeId}
      }
    },
  };

  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    keepInitApiParams: true,
    needLoading: false,
    ...args
  };
};

export { reduxTemplateConfig, templateConfig };
